import React from 'react';
import BorderedTicketBody from '../bordered-ticket/BorderedTicketBody';
import BorderedTicketFooter from '../bordered-ticket/BorderedTicketFooter';
import BorderedTicketHeader from '../bordered-ticket/BorderedTicketHeader';

function BorderedTicket(props) {
	
	const ticketData = props.ticketData;
	const frontendType = props.frontendType;
	const aamsEnviroment = props.aamsEnviroment; // TODO: add "isEstero" in configuration
	const isCashout = props.isCashout;
	const terminalCopy = props.terminalCopy;
	const printAgainTerminalRec = props.printAgainTerminalRec;
	const skinProperties = props.skinProperties;
	const user = props.user;
	const conf = props.conf;
	
	return <>
	<div id={"ticket-" + ticketData.idTicket} className="bordered-ticket-container">
		<BorderedTicketHeader customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} printAgainTerminalRec={printAgainTerminalRec} skinProperties={skinProperties}  conf={conf} terminalCopy={terminalCopy} isCashout={isCashout} user={user} ticketData={ticketData} frontendType={frontendType} aamsEnviroment={aamsEnviroment} />
		<BorderedTicketBody printAgainTerminalRec={printAgainTerminalRec} skinProperties={skinProperties}  conf={conf} terminalCopy={terminalCopy} isCashout={isCashout} user={user} ticketData={ticketData} frontendType={frontendType} aamsEnviroment={aamsEnviroment} />
		<BorderedTicketFooter customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} printAgainTerminalRec={printAgainTerminalRec} skinProperties={skinProperties}  conf={conf} terminalCopy={terminalCopy} isCashout={isCashout} user={user} ticketData={ticketData} frontendType={frontendType} aamsEnviroment={aamsEnviroment} />
	</div>
	</>
}

export default BorderedTicket;